import { NavLink, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { mangaCategories } from '@/mocks/categories';

const navItems = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category/shonen' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <NavLink to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500">
              <i className="ri-flower-line text-lg text-background-50"></i>
            </div>
            <span className="text-lg font-semibold text-foreground-950 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
              樱花动漫
            </span>
          </NavLink>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => {
              if (item.label === '分类') {
                return (
                  <div key={item.path} className="relative">
                    <button
                      onClick={() => setCategoryOpen(!categoryOpen)}
                      className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      分类
                      <i className={`ri-arrow-down-s-line text-sm transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
                    </button>
                    {categoryOpen && (
                      <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 bg-background-50 border border-background-200/70 rounded-xl py-2 px-1 shadow-sm min-w-[400px] z-50">
                        <div className="grid grid-cols-3 gap-1">
                          {mangaCategories.map((cat) => (
                            <NavLink
                              key={cat.slug}
                              to={`/category/${cat.slug}`}
                              onClick={() => setCategoryOpen(false)}
                              className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:bg-accent-100/80 hover:text-accent-700 transition-colors whitespace-nowrap"
                            >
                              <i className={`${cat.icon} text-base`}></i>
                              {cat.name}
                            </NavLink>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              }
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  className={({ isActive }) =>
                    `text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive ? 'text-accent-500' : 'text-foreground-700 hover:text-accent-500'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 px-4 py-2 pl-9 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-700 placeholder-foreground-600/50 focus:outline-none focus:border-accent-300 transition-colors"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-600 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/70 pt-3">
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  className={({ isActive }) =>
                    `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive ? 'bg-accent-100/80 text-accent-700' : 'text-foreground-700 hover:bg-background-100'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <div className="px-3 pt-2">
                <p className="text-xs text-foreground-600 mb-2">分类浏览</p>
                <div className="grid grid-cols-2 gap-1">
                  {mangaCategories.map((cat) => (
                    <NavLink
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 px-2 py-1.5 rounded-lg text-xs text-foreground-700 hover:bg-accent-100/80 transition-colors"
                    >
                      <i className={`${cat.icon} text-sm`}></i>
                      {cat.name}
                    </NavLink>
                  ))}
                </div>
              </div>
              <div className="px-3 pt-3">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="搜索漫画..."
                    className="w-full px-4 py-2 pl-9 text-sm bg-background-100 border border-background-200/70 rounded-full text-foreground-700 placeholder-foreground-600/50 focus:outline-none focus:border-accent-300 transition-colors"
                  />
                  <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-600 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}